import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
import { DeleteButtonProps } from "./delete-button.props";

export const DeleteButton = (props: DeleteButtonProps) => (
  <IconButton
    title={props.title}
    disabled={props.disabled}
    onClick={props.onClick}
    className="closeButton"
    aria-label="close"
    color="inherit"
    size={props.size || "small"}
  >
    <CloseIcon fontSize="inherit" />
  </IconButton>
);
